import { Tabs } from '@forgeglobal/design-framework';
import TabContent from '@tcs/common/components/atoms/TabContent';
import Header from '@tcs/client-portal-common/components/organisms/Header';
import DocumentDetails from '@tcs/client-portal-common/components/templates/DocumentDetails';
import { DocumentType } from '@tcs/client-portal-api/platform_generated';
import { Route } from 'react-router';

const Documents = () => {
  return (
    <Header
      pageTitle="Documents"
      tabs={() => (
        <Tabs>
          <Route
            path="*"
            element={
              <TabContent
                label="Statements"
                data-test-id="documents-statements-tab">
                <DocumentDetails
                  title="Quarterly Statements"
                  type={DocumentType.STATEMENT}
                  onlyActiveAccounts
                />
              </TabContent>
            }
          />
          <Route
            path="/tax_documents"
            element={
              <TabContent
                label="Tax Documents"
                data-test-id="documents-tax-documents-tab">
                <DocumentDetails
                  title="Tax Documents"
                  type={DocumentType.TAX}
                  onlyActiveAccounts
                />
              </TabContent>
            }
          />
        </Tabs>
      )}
    />
  );
};

export default Documents;
